module.exports = __webpack_public_path__ + "src/assets/img/customer-logos/slack.d6e80a7a1b1f72905b64fe17362886bc.png";